import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DIC } from '../../../dic';
import { GN } from '../../../../gn';

/**
 * Generated class for the AlerttypesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-alerttypes',
  templateUrl: 'alerttypes.html',
})
export class AlerttypesPage {

  alertTypes: any
  alerttype = ''


  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN) {
    this.alertTypes = this.navParams.get('alerttypes');
    this.alerttype = this.navParams.get('id');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AlerttypesPage');
    this.resetSearch()
  }

  goBack(_id, _name, _nameW) {

    var cb = this.navParams.get("callback")
    if (cb != null) {
      cb(_id, _name, _nameW)
    }
    this.navCtrl.pop()

  }


  resetSearch() {
    for (var i = 0; i < this.alertTypes.length; i++) {
      this.alertTypes[i].Visible = true
    }
  }
  getItems(ev: any) {
    var val = ev.target.value;
    if (val == null) { val = '' }
    val = val.toLowerCase()
    this.searchAlerts(val);

  }


  searchAlerts(val) {
    if (val && val.trim() != '') {
      for (var i = 0; i < this.alertTypes.length; i++) {
        if (this.alertTypes[i].nameHeader.length != 0) {
          this.alertTypes[i].Visible = false
        }
        else {
          if (this.gn._latcyr(this.dic.l[this.alertTypes[i].at.name].toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.dic.l[this.alertTypes[i].at.name].toLowerCase()).indexOf(val) > -1) {
            this.alertTypes[i].Visible = true
          } else {
            this.alertTypes[i].Visible = false
          }
        }
      }
    }
    else {
      this.resetSearch()
    }
  }



}



// WEBPACK FOOTER //
// ./src/pages/settings/alerts/alerttypes/alerttypes.ts